var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 20",
    width: 19,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #1e88e5 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M18.74 4L18.74 18C18.74 19.1 17.83 20 16.72 20L2.58 20C1.45 20 0.56 19.1 0.56 18L0.57 4C0.57 2.9 1.45 2 2.58 2L3.59 2L3.59 0L5.61 0L5.61 2L13.69 2L13.69 0L15.71 0L15.71 2L16.72 2C17.83 2 18.74 2.9 18.74 4ZM16.72 7L2.58 7L2.58 18L16.72 18L16.72 7ZM4.6 9L9.65 9L9.65 14L4.6 14L4.6 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlue);
export default __webpack_public_path__ + "static/media/calendar-blue.891e50f192022ee0caad27ee979c001d.svg";
export { ForwardRef as ReactComponent };